<template>
  <v-container>
    <v-menu>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
              mdi-dots-vertical
            </v-icon>
          </template>
          <span>Acciones</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item @click="crearPermisos()"> Crear permisos </v-list-item>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="selectComponent(item)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="suspenderUsuario()">
          Suspender Usuario
        </v-list-item>
      </v-list>
    </v-menu>

    <v-alert v-if="errores.length > 0" type="error" class="mt-4">
      <ul>
        <li v-for="(error, index) in errores" :key="index">
          {{
            error.response
              ? error.response.data.detail ||
                error.response.data.message ||
                "Error desconocido"
              : error.message
          }}
        </li>
      </ul>
    </v-alert>

    <v-alert v-if="mensaje" type="success" class="mt-4">
      {{ mensaje }}
    </v-alert>

    <v-dialog max-width="50%" v-model="dialog">
      <v-card v-if="selectedComponent === 'CrearAsignacion'">
        <CrearAsignacion :item="item" @cerrarDialog="cerrarDialog" />
      </v-card>

      <!-- <v-card v-if="selectedComponent === 'CrearPermisos'">
        <CrearPermisos :item="item" @cerrarDialog="cerrarDialog" />
        {{ crearPermisos() }}
      </v-card> -->
      <v-card v-if="selectedComponent === 'EliminarAsignacion'">
        <EliminarAsignacion
          :item="item"
          @cerrarDialog="cerrarDialog"
          @usuarioModificado="usuarioModificado"
        />
      </v-card>
      <!-- <v-card v-if="selectedComponent === 'SuspenderUsuario'">
        <SuspenderUsuario :item="item" @cerrarDialog="cerrarDialog" />
      </v-card> -->
      <v-card v-if="selectedComponent === 'RestablecerContraseña'">
        <RestablecerContrasena :item="item" @cerrarDialog="cerrarDialog" />
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
//import CrearAsignacion from "./CrearAsignacion.vue";
import { mapActions } from "vuex";
// import CrearPermisos from "./CrearPermisos.vue";
//import EliminarAsignacion from "./EliminarAsignacion.vue";
// import SuspenderUsuario from "./SuspenderUsuario.vue";
import RestablecerContrasena from "./RestablecerContrasena.vue";
import axios from "axios";
export default {
  props: ["item"],
  components: {
    //CrearAsignacion,
    // CrearPermisos,
    //EliminarAsignacion,
    // SuspenderUsuario,
    RestablecerContrasena,
  },
  data() {
    return {
      dialog: false,
      items: [
        /*
        {
          title: "Crear Asignacion",
          component: "CrearAsignacion",
        },
        */
        // {
        //   title: "Crear Permisos",
        //   component: "CrearPermisos",
        // },
        /*
        {
          title: "Eliminar Asignacion",
          component: "EliminarAsignacion",
        },
        */
        // {
        //   title: "Suspender Usuario",
        //   component: "SuspenderUsuario",
        // },
        {
          title: "Restablecer Contraseña",
          component: "RestablecerContraseña",
        },
      ],
      selectedComponent: null,
      errores: [],
      serverError: false,
      mensaje: "",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  methods: {
    usuarioModificado() {
      this.$emit("usuarioModificado");
    },
    async suspenderUsuario() {
      this.errores = [];
      this.mensaje = "";
      this.serverError = false;
      try {
        const response = await axios.put(
          `/usuarios/suspender_usuario?usuario_id=${this.item.id}`,
          {},
          {
            headers: {
              accept: "application/json",
            },
          }
        );
        // alert(JSON.stringify(response.data, null, 2));
        console.log(response);
        this.showSnackbar("Usuario suspendido.", "success");
        location.reload();
      } catch (error) {
        this.errores.push(error);
        this.serverError = true;
        this.showSnackbar("Error al suspender usuario.", "error");
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      }
    },
    async crearPermisos() {
      this.errores = [];
      this.mensaje = "";
      this.serverError = false;
      try {
        const response = await axios.post(
          `/usuarios/crear_permisos?usuario_id=${this.item.id}`,
          {},
          {
            headers: {
              accept: "application/json",
            },
          }
        );
        // const formattedData = JSON.stringify(response.data, null, 2);
        // alert(formattedData);
        if (response.data.mensajes.length === 0) {
          this.showSnackbar("Permisos creados.", "success");
          /*console.log("Mensaje: Permisos creados.");
          console.log(response);*/
          location.reload();
        } else {
          // Si hay mensajes, mostrarlos
          const mensajes = response.data.mensajes;
          if (mensajes.includes("El Usuario No Tiene Asignaciones")) {
            this.showSnackbar("El usuario no tiene asignaciones.", "warning");
            //console.log("Mensaje: El usuario no tiene asignaciones.");
          } else if (mensajes.includes("Error de Alncance de Plantilla")) {
            this.showSnackbar(mensajes.join(", "), "error");
            //console.log("Mensaje:", mensajes.join(", "));
          } else {
            // Otros mensajes
            this.showSnackbar(mensajes.join(", "), "info");
            //console.log("Otros mensajes:", mensajes.join(", "));
          }
        }
      } catch (error) {
        console.log("Error in crearPermisos:", error);
        this.errores.push(error);
        this.serverError = true;
        this.showSnackbar("Error al crear permisos.", "error");
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      }
    },
    selectComponent(item) {
      if (item.component) {
        this.selectedComponent = item.component;
        this.dialog = true;
      }
    },
    ...mapActions(["setPerfil"]),
    openPerfil(perfil) {
      this.setPerfil(perfil);
      this.$emit("openPerfil"); // Emit an event to the parent component
    },
    cerrarDialog(dialog) {
      this.dialog = dialog;
    },
    showSnackbar(text, color = "success") {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>
